import React, { useState, useEffect, useContext } from 'react';
import rainbowSDK from 'rainbow-web-sdk';
import './App.css';
import RainbowLogin from './Components/RainbowLogin.jsx';

import { Context } from './Context.js';
import MuiAlert from '@material-ui/lab/Alert';
import { Snackbar } from '@material-ui/core';
import { Suspense } from 'react';
import VurellaACD from './Components/VurellaACD';
// import VBoard from "./Components/VBoard";

//import Context from "./Context.js"

const onReady = () => {
  //console.log("SDK Initialized");
};

let onStopped = () => {
  //console.log("SDK Stopped");
  //window.location.reload();
};

const onSigned = () => {
  //sendMessage();
};

function App() {
  const [userAccount, setUserAccount] = useState({
    firstname: '',
    lastname: '',
    name: '',
    extension: '',
    channelobject: null,
    channelid: null,
    rainbowloggedin: false,
    acdloggedin: null,
    rainbowusername: '',
    rainbowpassword: '',
  });
  const [loginState, setLoginState] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);
  const [initState, setInitState] = useState(true);
  const [errorMsg, setErrorMsg] = useState('');

  function Alert(props) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleErrorClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setErrorOpen(false);
  };

  /* Add window object to allow debugging from the console */
  //window.rainbowSDK = rainbowSDK;

  useEffect(() => {
    //console.log("*** Welcome to Rainbow Web SDK for React ***");
    //console.log(jsMessageType.LOGIN.toString());
    rainbowSDK
      .initialize('fb92e5b0ba6d11e89693dd9cc99d33f6', 'Vg3v1CaHQbZQl2ELyUqtzK6wIwN8W3TBkVGhyaYZXed3aaR2ZGMAZuktiPVuaBdc')
      .then(function () {
        //console.log(rainbowSDK.RAINBOW_ONREADY);
        setInitState(true);
      })
      .catch((err) => {
        setErrorMsg(err.label);
      });
    document.addEventListener(rainbowSDK.RAINBOW_ONREADY, onReady);
    document.addEventListener(rainbowSDK.connection.RAINBOW_ONSTOPPED, onStopped);
    document.addEventListener(rainbowSDK.connection.RAINBOW_ONSIGNED, onSigned);
    //console.log(initState);
    rainbowSDK.load();
  }, []);

  const handleStateChange = (newState) => {
    // console.log("handlestate fired");
    setLoginState(newState);
    setInitState(!newState);
  };

  return (
    <Suspense fallback={<Loader />}>
      <Context.Provider value={[userAccount, setUserAccount]}>
        <React.Fragment>
          {/* <VBoard /> */}
          {!loginState && <RainbowLogin initState={initState} setInitState={setInitState} onChange={handleStateChange}></RainbowLogin>}
          {loginState && <VurellaACD onChange={handleStateChange}></VurellaACD>}
        </React.Fragment>
        <Snackbar open={errorOpen} autoHideDuration={6000} onClose={handleErrorClose}>
          <Alert onClose={handleErrorClose} severity='error'>
            Initializing Rainbow failed with error: {errorMsg}
          </Alert>
        </Snackbar>
      </Context.Provider>
    </Suspense>
  );
}

export default App;

const Loader = () => <div className='App'></div>;
